import styled from 'styled-components';

export const UserArticlesContainer = styled.div`
  position: relative;
  padding: 20px;
  background-color: white;
  border-radius: 4px;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    padding: 16px;
  }

  .userArticlesTitle {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 16px;
    color: ${(props) => props.theme.colors['terra-cotta']};
    text-transform: uppercase;
  }

  .error-msg {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    font-weight: 400;
  }

  .ant-collapse-item.ant-collapse-item-active {
    display: grid;
    gap: 20px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      gap: 16px;
    }
  }

  .userArticlesContent {
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    @media (max-width: 1200px) {
      gap: 15px;
    }

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      grid-template-columns: 1fr;
      justify-content: center;
      gap: 10px;
    }
  }

  .articleContent {
    display: grid;
    gap: 10px;
  }

  .mainArticleImageContainer {
    position: relative;
    aspect-ratio: 16 / 9;
  }

  .mainArticleImage {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 8px;
  }

  .mainArticleCountry {
    position: absolute;
    bottom: 10px;
    left: 20px;
  }

  .mainArticleCategory {
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 14px;
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .mainArticleTitle {
    font-family: ${(props) => props.theme.fonts.silkserif_black};
    font-size: 28px;
    line-height: 32px;
    color: #1f2b37;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      font-size: 24px;
      line-height: 28px;
    }
  }

  .mainArticleInfo {
    display: flex;
    flex-direction: row;
    align-items: center;
    opacity: 0.4;
    color: #1f2b37;
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 12px;
  }

  .mainArticleJournal {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 12px;
    margin-left: 10px;
    color: #1f2b37;
  }

  .mainArticleJournal span {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
  }

  .mainArticleText {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .linkArticle {
    color: #1f2b37;
  }

  .linkArticle:hover {
    cursor: pointer;
  }

  .linkArticle.underline {
    text-decoration: underline;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      display: none;
    }
  }

  .articleSeparator {
    height: 1px;
    background-color: #d8d8d8;
  }

  .articleContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .articleTitle {
    font-family: ${(props) => props.theme.fonts.silkserif_black};
    font-size: 16px;
    line-height: 16px;
    color: #1f2b37;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .articleBody {
    display: grid;
    gap: 6px;
    margin-left: 10px;
  }

  .articleImageContainer {
    height: 74px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      height: 92px;
    }
  }

  .articleImage {
    height: 100%;
    width: 140px;
    margin-left: auto;
    object-fit: cover;
    border-radius: 8px;
  }

  .loader {
    margin-top: 240px;
  }

  .articlesContainer {
    display: flex;
    flex-direction: column;
    margin-left: auto;
    justify-content: center;
    gap: 10px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      width: 100%;
      gap: 16px;
    }
  }

  .articleSeparatorContainer {
    margin: 5px;
    justify-content: center;
  }

  .userArticlesTitleContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .hideContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: auto;
    font-size: 12px;
    text-decoration: underline;
    font-family: ${(props) => props.theme.fonts.sfcompact};
    color: ${(props) => props.theme.colors.dark};

    p {
      margin-left: 10px;
    }
  }

  .hideContainer:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  .show-more-button {
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin-top: 16px;
    }
  }

  .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header
    .ant-collapse-expand-icon {
    height: 28px;
  }

  .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header
    .ant-collapse-expand-icon
    p {
    font-family: 'SFCompactText';
    color: #868e96;
  }

  .ant-collapse .ant-collapse-content > .ant-collapse-content-box {
    padding: 0;
  }
`;
